import {
  getSellers, postSeller, putSeller, exportSellers, importSellers,
} from '../../../Api/services/backoffice';

import office from '../../../Utils/Select/optionsLists/office';
import status from '../../../Utils/Select/optionsLists/status';

export const key = 'seller';

const entityName = {
  singular: 'Vendedor',
  plural: 'Vendedores',
};

const queries = {
  list: { key, fn: getSellers },
  detail: { key },
};

const mutations = {
  create: postSeller,
  update: putSeller,
};

const fields = {
  table: [
    { key: 'name', label: 'Nome' },
    { key: 'email', label: 'E-mail' },
    { key: 'higher.name', label: 'Superior' },
    { key: 'status', label: 'Status', mustRender: { componentType: 'status' } },
  ],
  search: [
    {
      param: 'search',
      label: 'Nome',
      type: 'text',
    },
    {
      param: 'office',
      label: 'Cargo',
      type: 'select',
      options: office,
    },
    {
      param: 'higherId',
      label: 'Superior',
      type: 'select',
      optionType: 'managers',
    },
    {
      param: 'status',
      label: 'Status',
      type: 'select',
      options: status,
    },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
  showBatchButton: true,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};

export const batchConfig = {
  entityName: entityName.plural,
  exportFn: exportSellers,
  importFn: importSellers,
};
